import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-conveyancer-sign-contract',
  templateUrl: './conveyancer-sign-contract.component.html',
  styleUrls: ['./conveyancer-sign-contract.component.scss']
})
export class ConveyancerSignContractComponent implements OnInit {

  constructor(private router: Router) { }

  submitForm() {
    this.router.navigateByUrl('');
  }

  ngOnInit(): void { }
}
